import Vue from 'vue'

Vue.mixin( {
  methods: {
    /**
     * Validate a form.
     * @param {Closure} callback 
     * @returns {Boolean|Null}
     */
    async validate(callback = null) {
      const validate = this.$validator && await this.$validator.validate()

      if (! validate) {
        return;
      }

      return callback ? callback() : validate
    }
  }
})